import { Box, Column, Row, Skeleton, SkeletonBox } from "@hightouch/htui";

// Loading placeholder for the Ad Studio landing (create-a-chat) surface, shown
// as the projects route's Suspense fallback. Mirrors the real layout of
// AdStudioProjects — a centered heading, the elevated chat input, and the
// wrapping row of quick-prompt tiles — with the same 7:13 vertical bias so
// nothing shifts when the real content arrives. Kept in its own module (not
// projects/index.tsx) so routes.tsx can import it statically as a fallback
// without pulling the lazy page chunk into the main bundle.

// One key per quick-prompt tile (QuickPrompts renders 5); string keys avoid the
// array-index-key lint rule on this static list.
const TILE_KEYS = ["a", "b", "c", "d", "e"];

export function AdStudioLandingSkeleton(): JSX.Element {
  return (
    <Column flex={1} minHeight={0} p={4} align="center">
      <Box flex={7} />
      <Column align="center" gap={10} flexShrink={0} width="100%">
        <Skeleton isLoading>
          <SkeletonBox
            height="32px"
            width="440px"
            maxWidth="90%"
            borderRadius="md"
          />
        </Skeleton>
        <Column width="100%" maxWidth="640px" gap={6}>
          <Skeleton isLoading>
            <SkeletonBox height="120px" width="100%" borderRadius="2xl" />
          </Skeleton>
          <Row gap={5} flexWrap="wrap" justify="space-between" width="100%">
            {TILE_KEYS.map((key) => (
              <Skeleton key={key} isLoading>
                <SkeletonBox width="112px" height="100px" borderRadius="2xl" />
              </Skeleton>
            ))}
          </Row>
        </Column>
      </Column>
      <Box flex={13} />
    </Column>
  );
}
